import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Dietitian } from '../../../../data/dietitian/domain/dietitian';
import {
  DietitianState,
  DietitianStateProvider,
} from '../../../../data/dietitian/domain/dietitian_state_provider';
import {
  BundledFeaturesModel,
  SubscriptionCommands,
} from '../../../../data/dietitian/domain/subscription/subscription_commands';
import {
  FeatureModel,
  SubscriptionModel,
} from '../account/routes/account-subscription/account-subscription.component';

@Injectable()
export class MsdAiShowcaseFacade {
  constructor(
    private subscriptionCommands: SubscriptionCommands,
    private dietitianStateProvider: DietitianStateProvider,
  ) {
    // Nada
  }

  get dietitianState$(): Observable<DietitianState> {
    return this.dietitianStateProvider.state$;
  }

  geLatestSubscription(
    dietitian: Dietitian,
  ): Promise<SubscriptionModel | undefined> {
    return this.subscriptionCommands.getLatestSubscription(dietitian);
  }

  async getFeatureModel(
    dietitian: Dietitian,
    code: string,
  ): Promise<FeatureModel> {
    return this.subscriptionCommands.getFeatureModel(dietitian, code);
  }

  async findAllBundledFeatures(
    featureId: string,
  ): Promise<BundledFeaturesModel[]> {
    return this.subscriptionCommands.findAllBundledFeatures(featureId);
  }
}
